import getSingleItemProductString from "../getSingleItemProductString";
import getEvents from "./getEvents";
import { MOVE_ITEM_TO_BAG_ACTION } from "../constants";
import {
  ADOBE_PRODUCTS_KEY,
  ADOBE_SAVED_ITEM_ACTION_KEY
} from "../../../../../../services/analytics/constants";

export const moveItemToBag = (
  state,
  { payload: { variantId, price, source, seller } }
) => ({
  ...state,
  trackLink: {
    products: getSingleItemProductString({
      variantId,
      quantity: 1,
      price,
      source,
      seller
    }),
    savedItemAction: MOVE_ITEM_TO_BAG_ACTION,
    events: getEvents({ price }),
    vars: [ADOBE_SAVED_ITEM_ACTION_KEY, ADOBE_PRODUCTS_KEY]
  }
});
